import { CSW_ON_HOMEPAGE } from 'shared/experiments/consts'
import { trackCswSlider } from 'shared/experiments/consts/trackCswSlider'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'

export default () => {
  const cswOnHomepage = getExperimentOnClient(CSW_ON_HOMEPAGE)

  if (cswOnHomepage.isEnabled) {
    void activateExperiment(CSW_ON_HOMEPAGE)

    trackCswSlider({ shouldTrackWithWidgetIds: true })
  }
}
